// @ts-nocheck
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { addToChainAfter } from "@toolkit/Modules/client-framework/HandlerCreator";

// Store Custom Code - Comes from classic
const pad = (n: number) => {
    return n < 10 ? `0${n}` : n;
};

addToChainAfter(chain, PopulateApiParameter, props => {
    if (!props.cartToUpdate) {
        return;
    }

    const {
        pages: {
            checkoutReviewAndSubmit: { requestedDeliveryDate },
        },
    } = props.getState();
    const tempDeliveryDate =
        typeof requestedDeliveryDate !== "undefined"
            ? requestedDeliveryDate
            : props.cartToUpdate.requestedDeliveryDateDisplay;

    let jonesRequestedDeliveryDate;
    if (tempDeliveryDate) {
        const jonesPickADate = `${tempDeliveryDate.getFullYear()}-${pad(tempDeliveryDate.getMonth() + 1)}-${pad(
            tempDeliveryDate.getDate(),
        )}`;
        jonesRequestedDeliveryDate = { jonesRequestedDeliveryDate: jonesPickADate };
    }

    if (jonesRequestedDeliveryDate?.jonesRequestedDeliveryDate) {
        props.apiParameter = {
            cart: {
                ...props.cartToUpdate,
                properties: {
                    ...props.cartToUpdate.properties,
                    ...jonesRequestedDeliveryDate,
                },
            },
        };
    }
});
